/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Metadata for a single RSA key pair associated with an entity. Includes the key ID, algorithm, and timestamps.
 */
export interface VmuaEntityKeyInfo { 
    /**
     * Unique identifier for this key pair (e.g. vmua-key-20260402-1f282bd6).
     */
    keyId?: string;
    /**
     * Cryptographic algorithm used (e.g. RSA-4096).
     */
    algorithm?: string;
    /**
     * Timestamp when the key was created.
     */
    createdTs?: Date;
}

